<template>
    <div>
        <label>添加附件：</label>
        <el-upload
            style="display:inline-block"
            class="upload-demo"
            ref="upload"
            :multiple="true"
            :action="URL.BASEURL + URL.fileUpload"
            :data="fileData"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-progress='uploadProgress'
            :file-list="fileList"
            accept=".jpg,.jpeg,.png,.gif,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.xls,.xlsx,.mp4,.docx,.eml,.EML"
            >
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitFile">上传到服务器</el-button> -->
            <div slot="tip" class="el-upload__tip">文件不可超过10M</div>
        </el-upload>
    </div>
</template>
<script>
export default {
    props:['fileOtherList','uploadOtherFile'],
    data(){
        return{
            fileData:{
                admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign
            },
            fileList:this.fileOtherList,
            uploadFile:this.uploadOtherFile,
        }
    },
    methods:{
        uploadProgress(){//上传中
            this.$loading(this.$loadingConfig);
        },
        uploadSuccess(res, file, fileList){
            this.$loading(this.$loadingConfig).close();
            if(res.errno == 0){
                this.uploadFile.push(res.rst.url)
            }else {
                this.$message({
                    message: res.err,
                    type: 'warning'
                })
            }

        },
        uploadError(err, file, fileList){
            this.$loading(this.$loadingConfig).close();
            this.$message({
                message: '上传失败',
                type: 'fail'
            })
        },
        fileExceed(file){
            this.$message({
                message: '超出限制，一次仅允许上传一个文件！',
                type: 'warning'
            })
        },
        handleRemove(file, fileList) {
            this.uploadFile = this.uploadFile.filter((v)=>{
                var url = '';
                if(file.response){
                    url = file.response.rst.url
                }else{
                    url = file.url
                }
                return v != url
            })
        },
        handlePreview(file) {
            console.log(file);
        },
    },
    watch:{
        uploadFile(){
            this.$emit('file',this.uploadFile)
        }
    }
}
</script>
<style lang="scss" scoped>
label{
    display: inline-block;
    width: 80px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/addFile.vue